import React, { Component } from 'react';
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
} from '@material-ui/core';
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import { StyledTableCell } from '../../commons/utils/TableStyles';
import { param } from 'jquery';

class PresupuestoGrid extends Component{   
	
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();
		this.inputRefs = [];
		this.state = {
			editMontoGeneral: false,
			editMontoPreventivo: false,
			editMontoCorrectivo: false,
			editMontoGestoria: false,
			editMontoVencimientos: false,
			presupuestos: [],
			loading: false,
			presupuestosBackup: [],
			totalAsignado: "",
			restante: ""

		}

		this.handleEdit = this.handleEdit.bind(this);
	}

	componentDidMount(){
		
	}

	componentWillMount() {
		this.ajaxHandler.subscribe(this);
		this.setState({ loading: true });
		this.initForm();
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	initForm(){
		let component = this;
		Promise.all([
			this.ajaxHandler.getJson('/' + this.props.modulo + '/' + this.props.id + '/presupuestos'),
			this.ajaxHandler.getJson('/presupuestos/' + this.props.presupuestable + '/' + this.props.id + '/total-asignado'),
			this.ajaxHandler.getJson('/presupuestos/' + this.props.presupuestable + '/' + this.props.id + '/restante')
		]).then((data) => {
			let presupuestos = [];
			data[0].forEach((presupuesto) => {
				presupuestos.push({
					id: presupuesto.id,
					monto_general: parseFloat(presupuesto.monto_general),
					monto_preventivo: parseFloat(presupuesto.monto_preventivo),
					monto_correctivo: parseFloat(presupuesto.monto_correctivo),
					monto_gestoria: parseFloat(presupuesto.monto_gestoria),
					monto_vencimientos: parseFloat(presupuesto.monto_vencimientos),
					periodo: presupuesto.periodo,
					editMontoGeneral: false,
					editMontoPreventivo: false,
					editMontoCorrectivo: false,
					editMontoGestoria: false,
					editMontoVencimientos: false,
				});
			});
			this.setState({ 
				presupuestos: presupuestos,
				presupuestosBackup: presupuestos,
				totalAsignado: data[1],
				restante:  data[2]
			});
		}).catch(function(error) {
			component.exit();
		}).finally(() => {
			this.setState({ loading: false });
		});
	}

	exit() {
		this.setState({
			redirectTo: '/bases'
		});
	}

	handleEdit(key, name){
		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		presupuestosCopy[key][name] = !presupuestosCopy[key][name]
		this.setState({
			presupuestos: presupuestosCopy
		}, () => {
			if (presupuestosCopy[key][name] && this.inputRefs[key+name]) {
				this.inputRefs[key+name].focus();
			}
		});
	}

	handleInputFormChange(event, key) {
		const target = event.target;
		const name = target.name;
		const value = target.value;

		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		presupuestosCopy[key][name] = value;
		this.setState({
			presupuestos: presupuestosCopy
		});
		}

	sendPresupuesto(key, name) {
		let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
		presupuestosCopy[key][name] = false;
		if(this.diferentePresupuesto(key)){
			this.props.setLoading(true);
			let component = this
			let body = {
				monto_general: parseFloat(presupuestosCopy[key].monto_general),
				monto_preventivo: parseFloat(presupuestosCopy[key].monto_preventivo),
				monto_correctivo: parseFloat(presupuestosCopy[key].monto_correctivo),
				monto_gestoria: parseFloat(presupuestosCopy[key].monto_gestoria),
				monto_vencimientos: parseFloat(presupuestosCopy[key].monto_vencimientos),
			}
			this.ajaxHandler.fetch('/presupuestos/' + presupuestosCopy[key].id, {
				method: 'PATCH',
				body: JSON.stringify({
					...body
				})
			}).then(response => {
				if(response.status !== 400) {
				} else {
					response.json()
					.then(data => {
						swal(data.detalle[0], "", "error");
					});
				}
			}).catch((error) => {
				component.ajaxHandler.handleError(error);
			}).finally(() => {
				component.initForm();
				this.props.setLoading(false);
			});

		}
	}

	diferentePresupuesto(key){
		if(this.state.presupuestos[key].monto_general !== this.state.presupuestosBackup[key].monto_general){
			return true
		}
		if(this.state.presupuestos[key].monto_preventivo !== this.state.presupuestosBackup[key].monto_preventivo){
			return true
		}
		if(this.state.presupuestos[key].monto_correctivo !== this.state.presupuestosBackup[key].monto_correctivo){
			return true
		}
		if(this.state.presupuestos[key].monto_gestoria !== this.state.presupuestosBackup[key].monto_gestoria){
			return true
		}
		if(this.state.presupuestos[key].monto_vencimientos !== this.state.presupuestosBackup[key].monto_vencimientos){
			return true
		}
		return false;
	}

	render() {
		return (
		<div className="card">
			<div className="card-content">
				<div className="card-body">
					<h4 className="form-section">
						<i className="las la-clipboard-list"></i><FormattedMessage id="presupuestoGrid.information.Presupuesto" defaultMessage="Presupuesto"/>
					</h4>
					<div className="row">
						<div className="col-md-6">
						<div className="form-group row">
							<label className="col-md-7 label-control col-form-label" htmlFor="descripcion">
								<FormattedMessage id="presupuestoGrid.presupuesto.presupuesto_total_asignado" defaultMessage="Presupuesto Total Asignado"/>:
							</label>
							<div className="col-md-5">
							<div className="form-control-static col-form-label">{this.state.totalAsignado}</div>
							</div>
						</div>
						</div>
						<div className="col-md-6">
						<div className="form-group row">
							<label className="col-md-7 label-control col-form-label" htmlFor="Presupuesto Restante">
							<FormattedMessage id="presupuestoGrid.presupuesto.presupuesto_restante" defaultMessage="Presupuesto Restante:"/>
							</label>
							<div className="col-md-5">
							<div className="form-control-static col-form-label">{this.state.restante}</div>
							</div>
						</div>
						</div>
					</div>
					<div className="row">
						<TableContainer>
							<Table aria-label="clases table">
								<TableHead>
									<TableRow>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto_table.column_nombre_periodo.label" defaultMessage="NOMBRE DEL PERIODO" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto_table.column_fecha_inicio.label" defaultMessage="FECHA INICIO" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto_table.column_fecha_fin.label" defaultMessage="FECHA FIN" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto_table.column_general.label" defaultMessage="GENERAL" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto_table.column_preventivo.label" defaultMessage="PREVENTIVO" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto_table.column_correctivo.label" defaultMessage="CORRECTIVO" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto.column_gestoria.label" defaultMessage="GESTORIA" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="presupuestoGrid.presupuesto.column_vencimientos.label" defaultMessage="VENCIMIENTO" />
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
								{this.state.loading && (
								<TableRow>
									<StyledTableCell colSpan={8} align="center">
									<FormattedMessage
										id="Cargando"
										defaultMessage="Cargando"
									/>
									</StyledTableCell>
								</TableRow>
								)}
								{!this.state.loading &&
								(this.state.presupuestos && this.state.presupuestos.map((presupuesto,key) => (
									<TableRow key={key}>
										<StyledTableCell align="left">{presupuesto.periodo ? presupuesto.periodo.nombre : ''}</StyledTableCell>
										<StyledTableCell align="left">{presupuesto.periodo ? presupuesto.periodo.fecha_inicio : ''}</StyledTableCell>
										<StyledTableCell align="left">{presupuesto.periodo ? presupuesto.periodo.fecha_fin : ''}</StyledTableCell>
										<StyledTableCell align="left">
											<div className="row-12" style={{ display: "flex", alignItems: "center"}}>
												<div className="row-8">
													{
														presupuesto.editMontoGeneral ? 
														(
															<input
																ref={el => this.inputRefs[key + "editMontoGeneral"] = el}
																id={key + "editMontoGeneral"}
																type="number"
																min="0"
																name="monto_general"
																style={{width: "130px",border:"1px solid #cacfe7"}}
																value={presupuesto.monto_general}
																onChange={(event) => this.handleInputFormChange(event, key)}
																onBlur={(e) => this.sendPresupuesto(key, "editMontoGeneral")}
															/>
														)
														: (presupuesto.monto_general === 0 ? 
															<span style={{paddingRight:"50px"}}></span>
															: 
															presupuesto.monto_general)
													}
												</div>
												<div className="row-4">
													{this.props.editar ? 
														<button
															type="button"
															className="btn btn-sm btn-icon btn-dt-grid text-success"
															data-title="Editar"
															data-togle="tooltip"
															data-placement="top"
															onClick={() => this.handleEdit(key, "editMontoGeneral")}
														>
															<i className="fa fa-pencil fa-xs" />
														</button>
													: ""}
												</div>
											</div>
										</StyledTableCell>
										<StyledTableCell align="left" className={presupuesto.monto_general > 0 ? "bg-light" : ""}>
											<div className="row-12" style={{ display: "flex", alignItems: "center"}}>
												<div className="row-8">
													{
														presupuesto.editMontoPreventivo ? 
														(
															<input
																ref={el => this.inputRefs[key + "editMontoPreventivo"] = el}
																id={key + "editMontoPreventivo"}
																type="number"
																min="0"
																name="monto_preventivo"
																style={{width: "130px",border:"1px solid #cacfe7"}}
																value={presupuesto.monto_preventivo}
																onChange={(event) => this.handleInputFormChange(event, key)}
																onBlur={(e) => this.sendPresupuesto(key, "editMontoPreventivo")}
															/>
														)
														: (presupuesto.monto_preventivo === 0 ? 
															<span style={{paddingRight:"50px"}}></span>
															: 
															presupuesto.monto_preventivo)
													}
												</div>
												<div className="row-4">
													{this.props.editar ? 
														presupuesto.monto_general > 0 ? 
														""
														: 
														<button
															type="button"
															className="btn btn-sm btn-icon btn-dt-grid text-success"
															data-title="Editar"
															data-togle="tooltip"
															data-placement="top"
															onClick={() => this.handleEdit(key, "editMontoPreventivo")}
														>
															<i className="fa fa-pencil fa-xs" />
														</button>
													: ""}
												</div>
											</div>
										</StyledTableCell>
										<StyledTableCell align="left" className={presupuesto.monto_general > 0 ? "bg-light" : ""}>
											<div className="row-12" style={{ display: "flex", alignItems: "center"}}>
												<div className="row-8">
													{
														presupuesto.editMontoCorrectivo ? 
														(
															<input
																ref={el => this.inputRefs[key + "editMontoCorrectivo"] = el}
																id={key + "editMontoCorrectivo"}
																type="number"
																min="0"
																name="monto_correctivo"
																style={{width: "130px",border:"1px solid #cacfe7"}}
																value={presupuesto.monto_correctivo}
																onChange={(event) => this.handleInputFormChange(event, key)}
																onBlur={(e) => this.sendPresupuesto(key, "editMontoCorrectivo")}
															/>
														)
														: (presupuesto.monto_correctivo === 0 ? 
															<span style={{paddingRight:"50px"}}></span>
															: 
															presupuesto.monto_correctivo)
													}
												</div>
												<div className="row-4">
													{this.props.editar ? 
														presupuesto.monto_general > 0 ? 
														""
														: 
														<button
															type="button"
															className="btn btn-sm btn-icon btn-dt-grid text-success"
															data-title="Editar"
															data-togle="tooltip"
															data-placement="top"
															onClick={() => this.handleEdit(key, "editMontoCorrectivo")}
														>
															<i className="fa fa-pencil fa-xs" />
														</button>
													: ""}
												</div>
											</div>
										</StyledTableCell>
										<StyledTableCell align="left" className={presupuesto.monto_general > 0 ? "bg-light" : ""}>
											<div className="row-12" style={{ display: "flex", alignItems: "center"}}>
												<div className="row-8">
													{
														presupuesto.editMontoGestoria ? 
														(
															<input
																ref={el => this.inputRefs[key + "editMontoGestoria"] = el}
																id={key + "editMontoGestoria"}
																type="number"
																min="0"
																name="monto_gestoria"
																style={{width: "130px",border:"1px solid #cacfe7"}}
																value={presupuesto.monto_gestoria}
																onChange={(event) => this.handleInputFormChange(event, key)}
																onBlur={(e) => this.sendPresupuesto(key, "editMontoGestoria")}
															/>
														)
														: (presupuesto.monto_gestoria === 0 ? 
															<span style={{paddingRight:"50px"}}></span>
															: 
															presupuesto.monto_gestoria)
													}
												</div>
												<div className="row-4">
													{this.props.editar ? 
														presupuesto.monto_general > 0 ? 
														""
														: 
														<button
															type="button"
															className="btn btn-sm btn-icon btn-dt-grid text-success"
															data-title="Editar"
															data-togle="tooltip"
															data-placement="top"
															onClick={() => this.handleEdit(key, "editMontoGestoria")}
														>
															<i className="fa fa-pencil fa-xs" />
														</button>
													: ""}
												</div>
											</div>
										</StyledTableCell>
										<StyledTableCell align="left" className={presupuesto.monto_general > 0 ? "bg-light" : ""}>
											<div className="row-12" style={{ display: "flex", alignItems: "center"}}>
												<div className="row-8">
													{
														presupuesto.editMontoVencimientos ? 
														(
															<input
																ref={el => this.inputRefs[key + "editMontoVencimientos"] = el}
																id={key + "editMontoVencimientos"}
																type="number"
																min="0"
																name="monto_vencimientos"
																style={{width: "130px",border:"1px solid #cacfe7"}}
																value={presupuesto.monto_vencimientos}
																onChange={(event) => this.handleInputFormChange(event, key)}
																onBlur={(e) => this.sendPresupuesto(key, "editMontoVencimientos")}
															/>
														)
														: (presupuesto.monto_vencimientos === 0 ? 
															<span style={{paddingRight:"50px"}}></span>
															: 
															presupuesto.monto_vencimientos)
													}
												</div>
												<div className="row-4">
													{this.props.editar ? 
														(presupuesto.monto_general > 0  ? 
														""
														: 
														<button
															type="button"
															className="btn btn-sm btn-icon btn-dt-grid text-success"
															data-title="Editar"
															data-togle="tooltip"
															data-placement="top"
															onClick={() => this.handleEdit(key, "editMontoVencimientos")}
														>
															<i className="fa fa-pencil fa-xs" />
														</button>)
													: ""}
												</div>
											</div>
										</StyledTableCell>
									</TableRow>
									)
								))
								}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
				</div>
			</div>
		</div>
		);
	}

} export default PresupuestoGrid;
